module.exports = __webpack_public_path__ + "static/media/photo_2.0f205dc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_2.jpg
// module id = 1635
// module chunks = 0